import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import {
    StyledBackground,
    StyledButtonContainer,
    StyledMainContainer
} from './styles'
import { orderPickUpType } from 'shared/utils/const'
import { KingTableWelcomeIcon } from 'app-v2/assets/icons'
import { TableCard } from 'app-v2/modules/king-table/features/welcome-screen/components'
import { PrimaryButton, PrimaryButtonOutlined } from 'app-v2/design-systems'
import { AuthenticationDuringOrder, Layout } from 'app/ecommerce/common'
import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { useHistory } from 'react-router-dom'
import { useTableStatus } from './hooks'
import { isMobile, isTablet } from 'react-device-detect'

export const KingTableWelcomeScreen = () => {
    const intl = useIntl()
    const [showAuthent, setShowAuthent] = useState(false)
    const authenticated = useSelector(
        (s: RootState) => s.userState.authenticated
    )
    const history = useHistory()

    useEffect(() => {
        if (!isMobile && !isTablet) {
            history.push(
                intl.formatMessage({ id: 'routes.kingtable.no-desktop' })
            )
        }
    }, [history, intl])

    const queryString = window.location.search
    const params = new URLSearchParams(queryString)
    const restaurant = params.get('restaurant') || ''
    const table = params.get('table') || ''
    const terrace = params.get('terrace') || 'false'
    const token = params.get('token') || ''
    const redirectToQueryParams = new URLSearchParams([
        ['restaurant', restaurant],
        ['table', table],
        ['terrace', terrace],
        ['token', token],
        ['collectmode', orderPickUpType.TABLE_ORDER]
    ])
    const catalogRoute =
        intl.formatMessage({ id: 'routes.clickandcollect.catalog' }) +
        '?' +
        redirectToQueryParams.toString()
    const tableStatus = useTableStatus(terrace === 'true')
    return (
        <Layout background="plain" border showLogoBK closeEnabled>
            <StyledMainContainer>
                <StyledBackground>
                    <KingTableWelcomeIcon size={210} />
                    <TableCard
                        restaurantPath={restaurant}
                        table={table}
                        terrace={terrace === 'true'}
                    />
                </StyledBackground>
            </StyledMainContainer>
            <StyledButtonContainer>
                {tableStatus === 'SUCCESS' ? (
                    <PrimaryButton
                        onClick={() =>
                            authenticated
                                ? history.push(catalogRoute)
                                : setShowAuthent(true)
                        }>
                        {intl.formatMessage({ id: 'continue' })}
                    </PrimaryButton>
                ) : (
                    <PrimaryButtonOutlined
                        variant={'outlined'}
                        onClick={() => history.goBack()}>
                        {intl.formatMessage({ id: 'cancel' })}
                    </PrimaryButtonOutlined>
                )}
            </StyledButtonContainer>
            <AuthenticationDuringOrder
                visible={showAuthent}
                setVisible={setShowAuthent}
                redirectTo={catalogRoute}
            />
        </Layout>
    )
}
